import axios from 'axios'
import { env } from '@/env'
const buildingLinkServerURL = env.VUE_APP_NODE_SERVER_BLK
//const communicationNodeServerURL = env.VUE_APP_communicationNodeServerURL
export const state = {
  servicesResident: null,
}
export const getters = {}
export const mutations = {
  SET_RESIDENT_SERVICES(state, newValue) {
    state.servicesResident = newValue
  },
}

export const actions = {
  async searchingRequestforResident({ commit, state, rootState }, data) {
    try {
      const getServices = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequests?$skip=${
          data.recordAvailable
        }&$orderby=ServiceRequestCreateDate desc &$filter=(contains(ServiceRequestForm/ServiceRequestFormName,'${
          data.requestName
        }')or contains(ServiceRequestForm/Provider/ProviderName,'${
          data.requestName
        }'))and ServiceRequestForm/Provider/SandOStatus eq 1 and ServiceRequestIsWaitingForProvider eq ${
          data.archieved
        }&$expand=ServiceRequestForm($expand=ServiceRequestFormCategory,Provider),ServiceRequestStatus,ServiceRequestFormOptionDatas($expand=ServiceRequestFormOption)`,
      })
      return getServices
    } catch (error) {
      throw error
    }
  },

  async getAllServicesRequestedByResident_Blk(
    { commit, state, rootState },
    data
  ) {
    try {
      const getServices = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequests?$orderby=ServiceRequestCreateDate desc&$filter=ServiceRequestForm/Provider/SandOStatus eq 1 and ServiceRequestIsWaitingForProvider eq ${
          data.archieved
        }&$expand=ServiceRequestForm($expand=ServiceRequestFormCategory,Provider),ServiceRequestStatus,ServiceRequestFormOptionDatas($expand=ServiceRequestFormOption)`,
      })
      return getServices
    } catch (error) {
      throw error
    }
  },
  async getAllServicesForadminLandingPage_BLK(
    { commit, state, rootState },
    data
  ) {
    try {
      const ServiceForms = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestForms?$count=true&$skip=${
          data.recordAvailable
        }&$orderby=ServiceRequestFormCreateDate desc&$expand=Provider,ServiceRequestFormsImages,ServiceRequestFormFacilityLinks($filter=ServiceRequestFormFacilityLinkFacId eq ${
          data.selectedBuildingID
        })&$filter=ServiceRequestFormFacilityLinks/any(c: c/ServiceRequestFormFacilityLinkFacId eq ${
          data.selectedBuildingID
        }) and Provider/SandOStatus eq 1 `,
      })
      const responseData = ServiceForms

      return responseData
    } catch (error) {
      throw error
    }
  },

  async getServiceDetailsByIdForResident_BLK(
    { commit, state, rootState },
    data
  ) {
    console.log('GET SERVICE DETAIL FROM BUILDINGLINK SERVER')
    try {
      const getServices = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestForms(${
          data.Id
        })?&$expand=Provider($select=ProviderName,ProviderEmail,ProviderPhone),ServiceRequestFormsImages,ServiceRequestFormOptions,ServiceRequestFormPrompts($expand=ServiceRequestFormPromptChoices)`,
      })
      const responseData = getServices.data

      console.log(
        ' SERVICE DETAIL FROM BUILDINGLINK SERVER : RESPONSE',
        responseData
      )
      return responseData
    } catch (error) {
      throw error
    }
  },
  async requestforEnquiry_BLK({ commit, state, rootState }, data) {
    try {
      const getServices = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}/ServiceRequestFormEnquiries`,
        data: data,
      })
      console.log('requestforEnquiry_BLK -> getServices', getServices)
      const responseData = getServices.data
      console.log('responseData', responseData)

      return responseData
    } catch (error) {
      throw error
    }
  },
  async ServiceRequest_BLK({ commit, state, rootState }, data) {
    try {
      const getServices = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}ServiceRequests`,
        data: data,
      })
      console.log('requestforEnquiry_BLK -> getServices', getServices)
      const responseData = getServices.data
      console.log('responseData', responseData)

      return responseData
    } catch (error) {
      throw error
    }
  },
  ServiceEmailCommunication_BLK({ commit, state, rootState }, data) {
    try {
      const getServices = axios({
        method: 'post',
        url: `${buildingLinkServerURL}emailCommunication`,
        // communicationNodeServerURL + '/api/v1.0/user/emailCommunication',
        data: data,
      })
      return true
    } catch (error) {
      return false
    }
  },

  async GetMessagesServiceRequestId_BLK({ commit, state, rootState }, data) {
    try {
      const getServices = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}getEmailCommunicationChat`,
        // communicationNodeServerURL +
        // '/api/v1.0/user/getEmailCommunicationChat',
        data: data,
      })

      const responseData = getServices
      console.log('responseData', responseData)

      return responseData
    } catch (error) {
      throw error
    }
  },
  async sendResponseMessagesServiceRequestId_BLK(
    { commit, state, rootState },
    data
  ) {
    try {
      const sendResponse = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}sendChatMessage`,
        // communicationNodeServerURL + '/api/v1.0/user/sendMessage',
        data: data,
      })

      const responseData = sendResponse
      console.log('responseData', sendResponse)
      return responseData
    } catch (error) {
      throw error
    }
  },

  async getProductInformationById({ commit, state, rootState }, data) {
    console.log('in getProductInformationById', data)
    try {
      const getproduct = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}/ServiceRequestFormOptions?$filter=ServiceRequestFormId eq ${
          data.Id
        }`,
      })
      console.log('response getProductInformationById', getproduct)

      return getproduct.data
    } catch (error) {
      throw error
    }
  },
  async getServiceImagesArrayById({ commit, state, rootState }, data) {
    try {
      const getImageArray = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}/ServiceRequestFormsImages?$filter=ServiceRequestFormId eq ${
          data.Id
        }`,
      })

      return getImageArray.data
    } catch (error) {
      throw error
    }
  },
  async getProviderByFacilityLink_BLK({ commit, state, rootState }, data) {
    try {
      const getServices = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestForms?$count=true&$top=21&$skip=${
          data.recordAvailable
        }&$orderby=ServiceRequestFormCreateDate desc&$expand=ServiceRequestFormsImages($select=ImageUrl),ServiceRequestFormCategory,Provider($select=ProviderId,ProviderName,ProviderEmail)
        &$filter=ServiceRequestFormFacilityLinks/any(c: c/ServiceRequestFormFacilityLinkFacId eq ${
          data.buildingId
        }) and  Provider/SandOStatus eq 1 and (contains( ServiceRequestFormName,'${
          data.searchKeyword
        }') or contains( Provider/ProviderName,'${data.searchKeyword}')) `,
      })

      return getServices.data
    } catch (error) {
      console.log('TCL: getAllService -> error', error)
      throw error
    }
  },

  async getResidentServicesBybuildingIdfunction(
    { commit, state, rootState },
    data
  ) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceFormsForResidentsAsync(searchKeyword='${
          data.searchKeyword
        }',sortingBy='${data.sorting}',buildingId=${
          data.buildingId
        },providerStatus=${data.providerStatus},pageSize=21,skipRecords=${
          data.recordAvailable
        })`,
      })
      const responseData = getDetails.data.value
      return responseData
    } catch (error) {
      throw error
    }
  },

  async sendUserServiceRequest({ commit, state, rootState }, data) {
    try {
      const responseData = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}ServiceRequests`,
        data: data,
      })
      console.log('Response', responseData)
      return responseData
    } catch (error) {
      console.log('TCL: sendUserServiceRequest -> error', error)
      throw error
    }
  },

  async inquiryRatingFeedback_BLK({ commit, state, rootState }, data) {
    try {
      const getEnquiries = await axios({
        method: 'patch',
        url: `${buildingLinkServerURL}ServiceRequestFormEnquiries(${data.Id})`,
        data: data.data,
      })
      return getEnquiries
    } catch (error) {
      throw error
    }
  },
  async GetMilestoneDetailsbyServiceRequestId(
    { commit, state, rootState },
    data
  ) {
    try {
      const getMilestones = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}GetMilestoneDetailsbyServiceRequestId(${
          data.serviceRequestId
        })`,
      })
      return getMilestones.data.value
    } catch (error) {
      throw error
    }
  },
  // -----------------------------------------------------------------------------------------------
  // Fetch Order List for Resident From Building link
  async GetOrderListbyResidentID({ commit, state, rootState }, data) {
    try {
      const getOrderList = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}GetOrderListbyResidentID?residentId=${
          data.residentId
        }&pageSize=100&skipRecords=${data.recordAvailable}&searchKeyword=${
          data.searchKeyword
        }`,
      })
      return getOrderList.data.value
    } catch (error) {
      throw error
    }
  },
  // -----------------------------------------------------------------------------------------------
  // Submit Refund Request
  async ServiceRequestRefundRequestByResident(
    { commit, state, rootState },
    data
  ) {
    try {
      const getOrderList = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}ServiceRequestRefundRequestByResident`,
        data: data,
      })
      return getOrderList.data.value
    } catch (error) {
      throw error
    }
  },
}
